import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';

const AutocompleteLoader = () => <CircularProgress color={'primary'} size={20} />;

export default AutocompleteLoader;
